module.exports = __webpack_public_path__ + "img/goal.30f7ba88.png";